import {getTestProps} from '@benchling/js-test-utils';
import classNames from 'classnames';
import React from 'react';

import {ContainableSummary} from 'constants/SampleConstants';
import ItemSearchInput from 'ui-library/attach-dropdown/ItemSearchInput';
import {ChipSize} from 'ui-library/chips/Chip';
import ErrorMessage from 'ui-library/ErrorMessage';
import {deprecatedSearchGet} from 'ui-library/inputs/ChipSearchInput';

export interface ContainableSearchInputProps {
  autoFocus: boolean;
  chipSize?: ChipSize;
  isReadOnly: boolean;
  error?: string;
  onChange: (containables: Array<ContainableSummary>) => void;
  selectedContainables: Array<ContainableSummary>;
}

export default function ContainableSearchInput(props: ContainableSearchInputProps): JSX.Element {
  return (
    <div {...getTestProps({component: 'ContainableSearchInput', element: 'root'})}>
      <ItemSearchInput
        autoFocus={props.autoFocus}
        chipSize={props.chipSize}
        className={classNames({'fieldInput-input--error': Boolean(props.error)})}
        doSearch={deprecatedSearchGet}
        isReadOnly={props.isReadOnly}
        itemKey="containables"
        onChange={props.onChange}
        placeholder="Search for an entity"
        searchURL="/1/api/containables:search"
        selectedItems={props.selectedContainables}
      />
      {props.error && <ErrorMessage error={props.error} />}
    </div>
  );
}
